module.exports = __webpack_public_path__ + "media/images/front/pc/default/noimage_s414x320-7b33f8b7887d14ee623930861bf90ba6.png";